// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"App__wrapper__3QGUb"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 26
// module chunks = 0